import { createContext, type ReactNode } from 'react'
import { type Ability, type Subject } from '@casl/ability'
import { createContextualCan } from '@casl/react'

import buildAbilityFor, { type Action } from './ability'
import { useAuth } from '../contexts/AuthContext'

type ContextAbility = Ability<[Action, Subject]>

type GuardProviderProps = {
  children: ReactNode
}

export const GuardContext = createContext<Ability<[Action, Subject]>>({} as ContextAbility)
export const Can = createContextualCan(GuardContext.Consumer)

export const GuardProvider = ({ children }: GuardProviderProps) => {
  const { user } = useAuth()

  const ability = buildAbilityFor(user?.type)

  return (
    <GuardContext.Provider value={ability}>
      {children}
    </GuardContext.Provider>
  )
}
